import Auth from "@aws-amplify/auth";
import { Badge } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ChevronLeftIcon from "@material-ui/icons/ArrowBack";
import SignOutIcon from "@material-ui/icons/ExitToApp";
import MenuIcon from "@material-ui/icons/Menu";
import clsx from "clsx";
import React from "react";
import { useHistory, useLocation } from "react-router";
import { DRAWER_WIDTH } from "../../constants/style";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: DRAWER_WIDTH,
    width: `calc(100% - ${DRAWER_WIDTH}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  hide: {
    display: "none",
  },
  wrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
}));

interface Props {
  handleDrawerOpen: () => void;
  open: boolean;
}

const istNestedRoute = (pathname = "") => {
  return pathname.split("/").length > 2;
};
const Header: React.FC<Props> = ({ handleDrawerOpen, open }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const history = useHistory();
  return (
    <AppBar
      color="primary"
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          className={clsx(classes.menuButton, {
            [classes.hide]: open,
          })}
        >
          <MenuIcon />
        </IconButton>
        <div className={classes.wrapper}>
          {!!istNestedRoute(pathname) && (
            <IconButton
              color="inherit"
              aria-label="´back"
              onClick={() => {
                const path = pathname.split("/");
                if (path.length > 2) {
                  history.goBack();
                }
              }}
            >
              <ChevronLeftIcon fontSize={"default"} />
            </IconButton>
          )}
          <Typography variant="h5">MAT</Typography>
        </div>
        <div className={classes.sectionDesktop}>
          <IconButton
            aria-label="show 4 new mails"
            color="inherit"
            onClick={() => Auth.signOut()}
          >
            <Badge color="secondary">
              <SignOutIcon />
            </Badge>
          </IconButton>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
